/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function TrashSolidMedium1(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'TrashSolidMedium1',
      'aria-hidden': true,
      focusable: false,
      width:  13 * scale,
      height: 15 * scale,
      viewBox: '0 0 13 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M2 13a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V6H2zm9-11H9a1 1 0 0 1-1-1H5a1 1 0 0 1-1 1H1v2h11V2z"}))
}
